import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';

const CSRF_ATTR_NAME = '_token';
const CSRF_COOKIE_NAME = 'csrf-token';

const INITIAL_OPTIONS = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
};

function setOptions(options: AxiosRequestConfig): AxiosRequestConfig {
  return {
    ...INITIAL_OPTIONS,
    ...options,
  };
}

type RequestData = { [key: string]: unknown } | FormData;

function setData(data: RequestData, url: string): RequestData {
  const csrfToken = Cookies.get(CSRF_COOKIE_NAME);
  if (csrfToken && url.startsWith('/panel')) {
    if (data instanceof FormData) {
      data.append(CSRF_ATTR_NAME, csrfToken);
    } else {
      return {
        ...data,
        [CSRF_ATTR_NAME]: csrfToken,
      };
    }
  }
  return data;
}

function httpPost<T>(
  url: string,
  data: RequestData = {},
  options: AxiosRequestConfig = { headers: { 'Content-Type': 'text/plain' } },
): AxiosPromise<T> {
  return axios.post(url, setData(data, url), setOptions(options));
}

function httpPatch<T>(url: string, data: RequestData = {}, options: AxiosRequestConfig = {}): AxiosPromise<T> {
  return axios.patch(url, setData(data, url), setOptions(options));
}

function httpGet<T>(url: string, options: AxiosRequestConfig = {}): AxiosPromise<T> {
  return axios.get(url, setOptions(options));
}

function httpDelete<T>(url: string, options: AxiosRequestConfig = {}): AxiosPromise<T> {
  return axios.delete(url, setOptions(options));
}

function createApiUrl(path: string): string {
  let baseUrl: string;
  switch (process.env.NEXT_PUBLIC_APP_ENV) {
    case 'dev':
      baseUrl = 'https://trustmate.test';
      break;

    case 'stage':
      baseUrl = 'https://trustmate.tech';
      break;

    case 'prod':
      baseUrl = 'https://trustmate.io';
      break;

    default:
      throw new Error(`APP_ENV ${process.env.NEXT_PUBLIC_APP_ENV} is not supported`);
  }

  return `${baseUrl}${path}`;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  get: httpGet,
  post: httpPost,
  patch: httpPatch,
  delete: httpDelete,
  createApiUrl,
};
